/**
 * Enum for EFT/POS Card Names.
 * @readonly
 * @enum {String} CardNameEnum
 */

const CardNameEnum = {
  JCB       : 'jcb',
  BNCT      : 'bancontact',
  VISA      : 'visa',
  MASTERCARD: 'mastercard',
  AMEX      : 'american express',
  DINERS    : 'diners club',
  MAESTRO   : 'maestro',
  DISCOVER  : 'discover',

  has: (type) => {
    return Object.values(CardNameEnum).includes(String(type).toLowerCase())
  }
}

export default CardNameEnum
